import { VolumeMeter } from '@/components/VolumeMeter'
import FakeMediaStreamTrack from '@/core/AudioEngine/FakeMediaStreamTrack'
import { AudioTrackWithInfo } from '@/UserContext'

type ChannelGroupMeterProps = {
    atrack: MediaStreamTrack | AudioTrackWithInfo | FakeMediaStreamTrack
    chgrp: number[]
    chLabel: string
    isMuted: boolean
    mutedStateTooltipText?: string
}
export function ChannelGroupMeter(props: ChannelGroupMeterProps) {
    return (
        <div className="flex items-center gap-[4px]">
            <div className="flex justify-start w-[16px]">
                <VolumeMeter
                    variant="pills"
                    stream={props.atrack}
                    channelCount={props.chgrp.length}
                    chgrp={props.chgrp}
                    isMuted={props.isMuted}
                    mutedStateTooltipText={props.mutedStateTooltipText}
                />
            </div>
            <div className="t-sm-light text-muse-fg/75 whitespace-nowrap">CH{props.chLabel}</div>
        </div>
    )
}
